import { ReactNode } from 'react';

import { makeStyles } from '@material-ui/core';

import { RiMore2Line } from '@remixicon/react';

import {
  ButtonIcon,
  Container,
  HeaderPage,
  HeaderPageBreadcrumb,
  HeaderTab,
  Menu,
  MenuItem,
  MenuTrigger,
} from '@backstage/ui';

import { SidebarContent, SidebarContentProps } from '../..';

const useStyles = makeStyles(theme => ({
  subheader: {
    marginBottom: theme.spacing(2),
  },
}));

export type PortalPageLayoutProps = {
  breadcrumbs?: HeaderPageBreadcrumb[];
  children: ReactNode;
  customActions?: ReactNode;
  menuItems?: { value: string; label: string; onClick: () => void }[];
  pageTitle: string;
  subheader?: ReactNode;
  tabs?: HeaderTab[];
} & Pick<SidebarContentProps, 'sideBarRight' | 'sideBarLeft'>;

export const PortalPageLayout = ({
  breadcrumbs,
  children,
  customActions,
  menuItems,
  pageTitle,
  sideBarLeft,
  sideBarRight,
  subheader,
  tabs,
}: PortalPageLayoutProps) => {
  const classes = useStyles();

  return (
    <div>
      <HeaderPage
        tabs={tabs}
        title={pageTitle}
        customActions={
          <>
            {customActions}
            {menuItems && (
              <MenuTrigger>
                <ButtonIcon variant="tertiary" icon={<RiMore2Line />} />
                <Menu placement="bottom end">
                  {menuItems.map(option => (
                    <MenuItem key={option.value} onClick={option.onClick}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Menu>
              </MenuTrigger>
            )}
          </>
        }
        breadcrumbs={breadcrumbs}
      />
      <Container>
        {subheader && <div className={classes.subheader}>{subheader}</div>}
        {sideBarLeft || sideBarRight ? (
          <SidebarContent sideBarLeft={sideBarLeft} sideBarRight={sideBarRight}>
            {children}
          </SidebarContent>
        ) : (
          children
        )}
      </Container>
    </div>
  );
};
